import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";

type Props = {
	title: string;
	titleType: string;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    titleType: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	titleType: string;
}



const className = computed(() => {
	let _classNameList = [];

	if (props.titleType) {
		_classNameList.push("_" + props.titleType);
	}

	return _classNameList.join(" ");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["UITitle", _unref(className)])
  }, _toDisplayString(props.title), 3))
}
}

})